import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const StyledTextSection = styled.section<{ alignment?: 'left' | 'center' | 'right' }>`
  max-width: 1340px;
  margin: 0 auto;
  text-align: ${({ alignment }) => alignment || 'left'};
  padding: 3rem 1rem 2.5rem 1rem;

  & h2 {
    font-family: Geomanist;
    font-weight: 500;
    font-size: 32px;
    vertical-align: middle;
    margin-bottom: 2rem;
    color: #0000ff;
    @media ${breakpoints.tablet} {
      font-size: 54px;
      margin-bottom: 5rem;
    }
  }

  & h3 {
    font-family: Geomanist;
    font-weight: 700;
    font-size: 30px;
    line-height: 42px;
    letter-spacing: 0;
    vertical-align: middle;
    background: linear-gradient(90deg, #0402fd 20%, #f4111b 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    padding: 2.5rem 0 1rem;
    @media ${breakpoints.tablet} {
      font-size: 40px;
    }
  }

  & .sub-highlight {
    font-family: Geomanist;
    font-weight: 500;
    font-size: 26px;
    line-height: 46px;
    vertical-align: middle;
    margin: 1.5rem 0 1rem;
    color: #0000ff;
    @media ${breakpoints.tablet} {
      font-size: 32px;
    }
  }

  & .description {
    margin-top: 1.5rem;

    & p {
      font-family: Roboto;
      font-weight: 400;
      font-size: 16px;
      line-height: 39px;
      color: #000;
      margin-bottom: 20px;
      @media ${breakpoints.tablet} {
        font-size: 24px;
      }
    }

    & strong {
      font-family: Roboto;
      font-weight: 700;
      font-size: 16px;
      line-height: 39px;
      @media ${breakpoints.tablet} {
        font-size: 24px;
      }
    }
  }

  .background-grey {
    background: #f7f9ff;
    padding: 0 1.5rem 1rem 1.5rem;
    @media ${breakpoints.desktop} {
      padding: 0 4rem 1rem 4rem;
    }
  }
`;
